export default "__VITE_ASSET__78500590__"